import _ from "lodash";
import { Member } from "./Member";
import { SpwkUtilV3 } from "./SpwkUtilV3";
import { UniAnswer } from "./UniAnswer";
import { new_ErrorAlert } from "../export_spwk/ExportManager";

/** 填寫一般問卷基本資料
 *
 * out_ans: 注意! Ans 的內容會被改變
 *
 * 回傳: 需要更新的 columns
 *
 * 各個 Form 不同版本可能都有不同的 匯入基本資料方式
 * 每個 case 各自管理遇到不同 form 時，要如何填入基本資料
 * 並回傳被影響到的 columns 用來 update_only
 */
export function FillCommonAnswer(
  out_ans: UniAnswer,
  member: Member,
  form_guid: string
): string[] {
  if (out_ans.IsSpwk() === true) {
    throw new_ErrorAlert("646816 特作問卷不應該用此方法填入基本資料 !!!");
  }

  let rhf_data = out_ans.ConvertToCommonRhfData(); //answer rhf_data

  switch (form_guid) {
    case SpwkUtilV3.FORM_GUID_F01v0:
      _.set(rhf_data, "m01.基本資訊●工號●input_1", member.employee_id);
      _.set(rhf_data, "m01.基本資訊●姓名●input_1", member.member_name);

      out_ans.m01 = JSON.stringify(_.get(rhf_data, "m01"), null, 4);

      return ["m01"];

      break;

    case SpwkUtilV3.FORM_GUID_F02v0:
      // pass;
      return [];
      break;

    case SpwkUtilV3.FORM_GUID_F03v0:
      let age = member.計算年齡();
      let work_year = member.計算年資_年();
      let work_month = member.計算年資_月(); //總共月份數取12的餘數

      _.set(rhf_data, "m01.基本資料●部門名稱●input_1", member.department);
      _.set(rhf_data, "m01.基本資料●職稱●input_1", member.job_title);
      _.set(rhf_data, "m01.基本資料●工號●input_1", member.employee_id);
      _.set(rhf_data, "m01.基本資料●姓名●input_1", member.member_name);
      _.set(rhf_data, "m01.基本資料●年齡●input_1", age);

      _.set(rhf_data, "m01.年資●年資年●input_1", work_year);
      _.set(rhf_data, "m01.年資●年資月●input_1", work_month);

      if (member.gender === 1) {
        _.set(rhf_data, "m01.性別", "男");
      } else if (member.gender === 2) {
        _.set(rhf_data, "m01.性別", "女");
      } else {
        //pass
      }

      out_ans.m01 = JSON.stringify(_.get(rhf_data, "m01"), null, 4);
      return ["m01"];

      break;

    case SpwkUtilV3.FORM_GUID_F04v0:
      _.set(rhf_data, "m01.基本資料●員工姓名●input_1", member.member_name); //姓名
      _.set(rhf_data, "m01.基本資料●員工編號●input_1", member.employee_id); //員工編號
      _.set(rhf_data, "m01.基本資料●部門●input_1", member.department); //部門
      out_ans.m01 = JSON.stringify(_.get(rhf_data, "m01"), null, 4);
      return ["m01"];

      break;

    case SpwkUtilV3.FORM_GUID_F05v0:
      _.set(rhf_data, "m01.基本資料●工號●input_1", member.employee_id); //員工編號
      _.set(rhf_data, "m01.基本資料●姓名●input_1", member.member_name); //姓名
      out_ans.m01 = JSON.stringify(_.get(rhf_data, "m01"), null, 4);
      return ["m01"];
      break;

    case SpwkUtilV3.FORM_GUID_F06v0:
      // pass;
      return [];
      break;

    default:
      throw new_ErrorAlert("4684646 未知的一般問卷設定基本資料方式 !!!");
      break;
  }
}
